import { types } from "../../types/types";

const initialState = {
    modulosPorContrato: [],
    loading: false,
};

export const contratacionesModulosReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.traerModulosPorContratoStart:
            return {
                ...state,
                loading: true,
            };
        case types.traerModulosPorContratoSuccess:
            return {
                ...state,
                modulosPorContrato: action.payload,
                loading: false,
            };
        case types.traerModulosPorContratoError:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
};
